var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"draws"},[_c('div',{staticClass:"draws__contents draws__contents__container"})])
}]

export { render, staticRenderFns }